// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-detail-page {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

.room-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}

.back-btn {
  padding: 8px 16px;
  background: #f5f5f5;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.room-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.room-title h1 {
  margin: 0;
  font-size: 28px;
}

.inline-edit {
  display: flex;
  gap: 10px;
  align-items: center;
}

.inline-edit input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 20px;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.room-tabs {
  display: flex;
  gap: 5px;
  border-bottom: 2px solid #eee;
  margin-bottom: 20px;
}

.tab {
  padding: 12px 20px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
}

.tab:hover {
  color: #333;
}

.tab.active {
  color: #4a90e2;
  border-bottom-color: #4a90e2;
}

.tab-actions {
  margin-bottom: 20px;
}

.participants-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.participant-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.participant-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.participant-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #4a90e2;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.participant-name {
  font-weight: 500;
}

.participant-email {
  font-size: 12px;
  color: #666;
}

.role-badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
}

.role-badge.owner {
  background: #ffd700;
  color: #333;
}

.role-badge.admin {
  background: #e3f2fd;
  color: #1976d2;
}

.role-badge.member {
  background: #f5f5f5;
  color: #666;
}

.participant-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.participant-actions select {
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.meetings-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.meeting-card {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.meeting-info h3 {
  margin: 0 0 5px 0;
}

.meeting-info p {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.status-badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
}

.status-badge.active {
  background: #e8f5e9;
  color: #2e7d32;
}

.status-badge.ended {
  background: #f5f5f5;
  color: #666;
}

.settings-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.settings-section h3 {
  margin: 0 0 15px 0;
}

.settings-form .form-group {
  margin-bottom: 15px;
}

.settings-form label {
  display: block;
  margin-bottom: 5px;
  color: #666;
}

.settings-form input[type="text"],
.settings-form input[type="number"],
.settings-form textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.settings-form input[type="checkbox"] {
  margin-right: 8px;
}

.danger-zone {
  border: 1px solid #ffcdd2;
}

.danger-zone h3 {
  color: #c62828;
}

.btn-danger {
  padding: 10px 20px;
  background: #c62828;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-danger:hover {
  background: #b71c1c;
}

.btn-sm {
  padding: 5px 10px;
  font-size: 12px;
}

.notification-settings h4 {
  margin: 0 0 10px 0;
}

.toggle-label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.toggle-label input {
  margin-right: 10px;
}

.info-text {
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
}

.empty-message {
  text-align: center;
  color: #666;
  padding: 40px;
}

/* Invitations Tab */
.invitations-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.invitation-card {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.invitation-info {
  flex: 1 1;
}

.invitation-role {
  margin-bottom: 8px;
}

.invitation-stats {
  display: flex;
  gap: 15px;
  font-size: 12px;
  color: #666;
  margin-bottom: 10px;
}

.invitation-link {
  display: flex;
  gap: 10px;
}

.invitation-link input {
  flex: 1 1;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  background: #f5f5f5;
}

/* Modal styles (same as Rooms.css) */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: white;
  border-radius: 8px;
  padding: 30px;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal h2 {
  margin: 0 0 20px 0;
  color: #333;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #666;
  font-size: 14px;
}

.form-group input[type="text"],
.form-group input[type="number"],
.form-group input[type="email"],
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-group input[type="checkbox"] {
  margin-right: 8px;
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}

.btn-primary {
  padding: 10px 20px;
  background: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-secondary {
  padding: 10px 20px;
  background: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.error-message {
  background: #fee;
  color: #c00;
  padding: 10px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.loading {
  text-align: center;
  padding: 60px;
  color: #666;
}

/* Recordings Tab */
.recordings-tab {
  padding: 20px 0;
}

.recordings-tab .recordings-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.recording-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.recording-info h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #333;
}

.recording-info p {
  margin: 4px 0;
  font-size: 14px;
  color: #666;
}

.recording-actions {
  display: flex;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/RoomDetail.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;;;;;EAKE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX","sourcesContent":[".room-detail-page {\r\n  max-width: 1000px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n}\r\n\r\n.room-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.back-btn {\r\n  padding: 8px 16px;\r\n  background: #f5f5f5;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.room-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.room-title h1 {\r\n  margin: 0;\r\n  font-size: 28px;\r\n}\r\n\r\n.inline-edit {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.inline-edit input {\r\n  padding: 8px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 20px;\r\n}\r\n\r\n.btn-icon {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n}\r\n\r\n.room-tabs {\r\n  display: flex;\r\n  gap: 5px;\r\n  border-bottom: 2px solid #eee;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.tab {\r\n  padding: 12px 20px;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: #666;\r\n  border-bottom: 2px solid transparent;\r\n  margin-bottom: -2px;\r\n}\r\n\r\n.tab:hover {\r\n  color: #333;\r\n}\r\n\r\n.tab.active {\r\n  color: #4a90e2;\r\n  border-bottom-color: #4a90e2;\r\n}\r\n\r\n.tab-actions {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.participants-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.participant-card {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 15px;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.participant-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n\r\n.participant-avatar {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  background: #4a90e2;\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: bold;\r\n}\r\n\r\n.participant-name {\r\n  font-weight: 500;\r\n}\r\n\r\n.participant-email {\r\n  font-size: 12px;\r\n  color: #666;\r\n}\r\n\r\n.role-badge {\r\n  padding: 4px 10px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n}\r\n\r\n.role-badge.owner {\r\n  background: #ffd700;\r\n  color: #333;\r\n}\r\n\r\n.role-badge.admin {\r\n  background: #e3f2fd;\r\n  color: #1976d2;\r\n}\r\n\r\n.role-badge.member {\r\n  background: #f5f5f5;\r\n  color: #666;\r\n}\r\n\r\n.participant-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.participant-actions select {\r\n  padding: 5px 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n}\r\n\r\n.meetings-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.meeting-card {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 15px;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.meeting-info h3 {\r\n  margin: 0 0 5px 0;\r\n}\r\n\r\n.meeting-info p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.status-badge {\r\n  padding: 4px 10px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n}\r\n\r\n.status-badge.active {\r\n  background: #e8f5e9;\r\n  color: #2e7d32;\r\n}\r\n\r\n.status-badge.ended {\r\n  background: #f5f5f5;\r\n  color: #666;\r\n}\r\n\r\n.settings-section {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.settings-section h3 {\r\n  margin: 0 0 15px 0;\r\n}\r\n\r\n.settings-form .form-group {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.settings-form label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  color: #666;\r\n}\r\n\r\n.settings-form input[type=\"text\"],\r\n.settings-form input[type=\"number\"],\r\n.settings-form textarea {\r\n  width: 100%;\r\n  padding: 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n}\r\n\r\n.settings-form input[type=\"checkbox\"] {\r\n  margin-right: 8px;\r\n}\r\n\r\n.danger-zone {\r\n  border: 1px solid #ffcdd2;\r\n}\r\n\r\n.danger-zone h3 {\r\n  color: #c62828;\r\n}\r\n\r\n.btn-danger {\r\n  padding: 10px 20px;\r\n  background: #c62828;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-danger:hover {\r\n  background: #b71c1c;\r\n}\r\n\r\n.btn-sm {\r\n  padding: 5px 10px;\r\n  font-size: 12px;\r\n}\r\n\r\n.notification-settings h4 {\r\n  margin: 0 0 10px 0;\r\n}\r\n\r\n.toggle-label {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.toggle-label input {\r\n  margin-right: 10px;\r\n}\r\n\r\n.info-text {\r\n  color: #666;\r\n  font-size: 14px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.empty-message {\r\n  text-align: center;\r\n  color: #666;\r\n  padding: 40px;\r\n}\r\n\r\n/* Invitations Tab */\r\n.invitations-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.invitation-card {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  padding: 15px;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.invitation-info {\r\n  flex: 1;\r\n}\r\n\r\n.invitation-role {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.invitation-stats {\r\n  display: flex;\r\n  gap: 15px;\r\n  font-size: 12px;\r\n  color: #666;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.invitation-link {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.invitation-link input {\r\n  flex: 1;\r\n  padding: 8px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  background: #f5f5f5;\r\n}\r\n\r\n/* Modal styles (same as Rooms.css) */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 30px;\r\n  max-width: 500px;\r\n  width: 90%;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal h2 {\r\n  margin: 0 0 20px 0;\r\n  color: #333;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.form-group label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  color: #666;\r\n  font-size: 14px;\r\n}\r\n\r\n.form-group input[type=\"text\"],\r\n.form-group input[type=\"number\"],\r\n.form-group input[type=\"email\"],\r\n.form-group textarea,\r\n.form-group select {\r\n  width: 100%;\r\n  padding: 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.form-group input[type=\"checkbox\"] {\r\n  margin-right: 8px;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  justify-content: flex-end;\r\n  margin-top: 20px;\r\n}\r\n\r\n.btn-primary {\r\n  padding: 10px 20px;\r\n  background: #4a90e2;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-secondary {\r\n  padding: 10px 20px;\r\n  background: #f5f5f5;\r\n  color: #333;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.error-message {\r\n  background: #fee;\r\n  color: #c00;\r\n  padding: 10px 15px;\r\n  border-radius: 4px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.loading {\r\n  text-align: center;\r\n  padding: 60px;\r\n  color: #666;\r\n}\r\n\r\n/* Recordings Tab */\r\n.recordings-tab {\r\n  padding: 20px 0;\r\n}\r\n\r\n.recordings-tab .recordings-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.recording-card {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 15px;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.recording-info h3 {\r\n  margin: 0 0 8px 0;\r\n  font-size: 16px;\r\n  color: #333;\r\n}\r\n\r\n.recording-info p {\r\n  margin: 4px 0;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.recording-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
